const tareaEnumerators = {
  respuesta: ['Si', 'No'],
  estado: [
    'Abierta',
    'Cerrada',
    'Rechazada',
    'FueraPlazo',
    'PendienteRevision',
    'EnRevision',
    'requestedSignature',
    'signedByUser',
    'partialRequested',
    'partialVerified',
    'notPartialVerified',
    'notRequested',
  ],
  secondaryState: ['requestedSignature', 'signedByUser', 'partialRequested', 'partialVerified', 'notRequested'],
  stateProcess: ['Open', 'InProgress', 'PendingValidation', 'Closed'],
  dirigidoA: ['Puesto', 'Ejecutor'],
  tipoVisualizacion: ['Ciclico1', 'Pasos', 'Estandar', 'Checklist', 'Procedimiento'],
  tipoMantenimiento: ['Preventiva', 'Programada', 'Correctiva', 'Predictiva'],
  tipoTarea: ['Estandar', 'Personalizada', 'Modelo', 'Operativa', 'Mantenimiento', 'Incidente'],
  clasificacion: [
    'operativa',
    'mantenimiento',
    'incidente',
    'investigacionIncidente',
    'inspeccion',
    'observacion',
  ],
  prioridad: ['Baja', 'Media', 'Alta'],
  estadoFirma: ['sinSolicitud', 'Pendiente', 'Aprobada', 'Rechazada'],
};

export default tareaEnumerators;
